import { Component } from "@angular/core";

import { OnInit } from "@angular/core";

import { MedicineService } from "../../services/medicine.services";
import { LocationService } from "../../services/location.services";
import { BatchService } from "../../services/batch.services";
import { GlobalCfgService } from 'src/services/globalcfg.service';

@Component({
  selector: "rm-recall-simulation",
  templateUrl: "./recall-simulation.component.html",
  styleUrls: ["./recall-simulation.component.css"]
})
export class RecallSimulationComponent implements OnInit {
  searchTxt: string = "";
  selectedProduct: string = "all";
  selectedLocation: string = "all";
  searchByBatch: boolean = false;

  expiryData: any[] = [];
  columns: any[] = [
    { name: "img", displayName: "", type: "image" },
    {
      name: "name",
      displayName: "Medicine",
      actionable: true,
      tip: "View Medicine Detail"
    },
    {
      name: "gtin",
      displayName: "GTIN",
      actionable: true,
      tip: "View GTIN Detail"
    },
    {
      name: "batchNo",
      displayName: "Batch No.",
      actionable: true,
      tip: "View Batch Detail"
    },
    { name: "actions", displayName: "Batch Actions" },
    { name: "expiryDt", displayName: "Expiry Date" },
    { name: "location", displayName: "Mfg Location" },
    {
      name: "viewOnMap",
      displayName: "",
      actionable: true,
      actionableIcon: "map",
      tip: "View Distribution"
    }
  ];
  products: any[] = [];
  locations: any[] = [];
  gcp: any;

  constructor(
    private medicineService: MedicineService,
    private locationService: LocationService,
    private batchService: BatchService,
    private globalCfgService: GlobalCfgService
  ) {}

  ngOnInit() {
    this.gcp = this.globalCfgService.getGcp();

    this.loadRecallData(this.gcp);
    this.loadProducts();
    this.loadLocations();
  }

  loadRecallData(gcp) {
    var obj = {};

    if (gcp) {
      obj['gcp'] = gcp;
    }

    this.batchService.details(obj).subscribe((response: any) => {
      this.expiryData = response;
    });
  }

  loadProducts() {
    this.medicineService.get(this.gcp).subscribe((response: any) => {
      this.products = response;
    });
  }

  loadLocations() {
    this.locationService.get(this.gcp).subscribe((response: any) => {
      this.locations = response;
      // this.locations = [
      //   {name: 'Austrak, Hyderabad'},
      //   {name: 'Austrak, Badi'}
      // ];
    });
  }

  setSearchByBatch(status) {
    if (!status && this.searchTxt.length > 0) {
      return;
    }
    this.searchByBatch = status;
  }

  clear() {
    this.searchTxt = "";
    this.searchByBatch = false;
  }
}
